import { Button, Col, Form, Modal } from "react-bootstrap";
import { ArrowClockwise, ImageFill, PencilFill, Send, XLg } from "react-bootstrap-icons";
import Avatar from "./reusable/Avatar";
import useWritePost from "../hooks/useWritePost";

const ConnectWritePost = ({ user, authorName, refetch }) => {
  const {
    message,
    setMessage,
    show,
    setShow,
    fileSize,
    characterLimit,
    canSubmit,
    handleImageChange,
    handleSubmit,
    handleReset,
  } = useWritePost(user, authorName, refetch);

  return (
    <>
      {/* Trigger */}
      {!show && (
        <div className="write-post-trigger" onClick={() => setShow(true)}>
          <Avatar size="md" />
          <div className="write-post-input-placeholder">
            What's on your mind?
          </div>
          <PencilFill style={{ color: "var(--accent)", fontSize: "18px" }} />
        </div>
      )}

      {/* Modal */}
      {show && (
        <Modal show={show} onHide={() => setShow(false)} backdrop="static" size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title className="h6 fw-bold">Create post</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center gap-3 mb-3">
              <Avatar size="md" />
              <div>
                <div className="fw-bold" style={{ fontSize: "15px", color: "var(--text-primary)" }}>
                  {authorName ?? "You"}
                </div>
                <div style={{ fontSize: "12px", color: "var(--text-tertiary)" }}>
                  Posting publicly
                </div>
              </div>
            </div>

            <Form className="d-flex flex-column gap-3">
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Write something interesting..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                maxLength={255}
                style={{
                  border: "none",
                  resize: "none",
                  fontSize: "16px",
                  background: "transparent",
                  color: "var(--text-primary)",
                  padding: "0",
                }}
              />

              <Col className="d-flex justify-content-between">
                <Form.Text style={{ color: "var(--text-tertiary)" }}>
                  Max 255 characters
                </Form.Text>
                <Form.Text
                  style={{
                    color:
                      characterLimit < 20
                        ? "var(--like-color)"
                        : "var(--text-tertiary)",
                    fontWeight: characterLimit < 20 ? 700 : 400,
                  }}
                >
                  {characterLimit}
                </Form.Text>
              </Col>

              <div
                className="d-flex align-items-center justify-content-between p-3"
                style={{
                  border: "1px solid var(--border-light)",
                  borderRadius: "var(--radius-sm)",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "var(--text-primary)",
                  }}
                >
                  Add to your post
                </span>
                <label
                  htmlFor="addImage"
                  style={{
                    cursor: "pointer",
                    color: "var(--success-color)",
                    fontSize: "22px",
                  }}
                  title="Add photo"
                >
                  <ImageFill />
                </label>
                <Form.Control
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  id="addImage"
                  name="addImage"
                  onChange={() => handleImageChange("addImage")}
                  className="d-none"
                />
              </div>

              {fileSize > 100000 && (
                <small
                  style={{
                    color: "var(--like-color)",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  File cannot exceed 100 KB.
                </small>
              )}

              <div className="d-flex gap-2">
                <Button
                  className="btn-accent flex-grow-1 d-flex align-items-center justify-content-center gap-2"
                  disabled={!canSubmit}
                  onClick={handleSubmit}
                  style={{ opacity: canSubmit ? 1 : 0.5 }}
                >
                  <Send /> Post
                </Button>
                <button
                  type="button"
                  className="btn-ghost px-3"
                  onClick={handleReset}
                  title="Reset"
                >
                  <ArrowClockwise />
                </button>
                <button
                  type="button"
                  className="btn-ghost px-3"
                  onClick={() => setShow(false)}
                  title="Cancel"
                >
                  <XLg />
                </button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ConnectWritePost;
